export function AccessPrevilegesFunction(previlage) {
    const currentUserPrevilages = JSON.parse(localStorage.getItem('user'))?.profile?.PRIVILAGES || [];
    return currentUserPrevilages.includes(previlage);
}

// Privileges configurable independently per product category (IWB/MnR), e.g. bulk_deal_visibility.
// Returns true if the given privilege is granted for at least one category.
export function AccessCategoryPrevilegesFunction(previlage) {
    const categoryPrevilages = JSON.parse(localStorage.getItem('user'))?.profile?.CATEGORY_PRIVILAGES || {};
    return Object.values(categoryPrevilages).some((privileges) => privileges?.includes(previlage));
}

// Same IWB/MnR grouping used across the app (see services/orders/data/list_items.py):
// only 'MnR' (case-insensitive) is the MnR group, everything else (CONSUMABLES/Consumables/
// EQUIPMENT/Equipments/EQUIPMENTS/SGP/OTHERS/TRADING) is IWB. PRODUCT_CATEGORIES entries can
// be dot-path segments (e.g. "EQUIPMENT.Hardfacing"), so only the top-level segment matters.
function ResolveCategoryGroup(productCategory) {
    const topLevel = String(productCategory).trim().split('.')[0];
    return topLevel.toUpperCase() === 'MNR' ? 'MnR' : 'IWB';
}

// Restricts a distributor's PRODUCT_CATEGORIES down to only the ones whose IWB/MnR group
// actually has the given privilege, e.g. price_list_visibility - so a distributor can only
// ever get content for categories they're both assigned to AND privileged for.
export function FilterCategoriesByPrevilege(previlage, productCategories) {
    const categoryPrevilages = JSON.parse(localStorage.getItem('user'))?.profile?.CATEGORY_PRIVILAGES || {};
    return (productCategories || []).filter((category) => (
        categoryPrevilages?.[ResolveCategoryGroup(category)]?.includes(previlage) || false
    ));
}

// Per-order privilege check, e.g. return_order, gated by the order's own product
// category rather than the distributor's privileges as a whole. Falls back to the
// flat privilege check when the order's category couldn't be resolved.
export function AccessOrderCategoryPrevilegeFunction(previlage, productCategory) {
    if (!productCategory) {
        return AccessPrevilegesFunction(previlage);
    }
    const categoryPrevilages = JSON.parse(localStorage.getItem('user'))?.profile?.CATEGORY_PRIVILAGES || {};
    const group = ResolveCategoryGroup(productCategory);
    return categoryPrevilages?.[group]?.includes(previlage) || false;
}
